export enum BuildEpoch {
    UNKNOWN = 0,
    STALIN = 1,
    BREZHNEV = 2,
    KHRUSHCHEV = 3
}
